<template>
  <div>
    <h2 class="content-heading">
      <i class="si si-tag mr-5"></i> Producten
    </h2>

    <api-table-block ref="productsTable" :fields="fields" :items="findAllProducts" default-sort-by="created_at" item-label-singular="product" item-label-plural="producten">
      <template slot="name" slot-scope="data">
        <a href="#" @click.prevent="details(data.item)">{{data.value}}</a>
      </template>
      <template slot="location" slot-scope="data">
        <div>
          <location-editable field="location" :value="data.item.location" :product-id="data.item.id" :key="data.item.id"></location-editable>
        </div>
        <div>
          <small>
            Rest:
            <field-editable field="overstock_location" :value="data.item.overstock_location" :product-id="data.item.id" :key="data.item.id"></field-editable>
          </small>
        </div>
      </template>
      <template slot="in_store" slot-scope="data">
        <in-store-editable :in-store="!!data.value" :product-id="data.item.id" :key="data.item.id"></in-store-editable>
      </template>
      <template slot="stock_quantity" slot-scope="data">
        <stock-editable :quantity="data.value" :product-id="data.item.id" :key="data.item.id"></stock-editable>
      </template>
    </api-table-block>
    <product-detail-modal v-if="detailModalProductId" :key="detailModalProductId" :product-id="detailModalProductId" @close="detailModalProductId = null" @remove="refresh"></product-detail-modal>
  </div>
</template>

<script>
import http from '../utils/http'
import LocationEditable from './LocationEditable'
import FieldEditable from './FieldEditable'
import StockEditable from './StockEditable'
import InStoreEditable from './InStoreEditable'
import ApiTableBlock from '../common/ApiTableBlock'
import ProductDetailModal from './ProductDetailModal'

export default {
  components: {
    LocationEditable,
    FieldEditable,
    StockEditable,
    InStoreEditable,
    ApiTableBlock,
    ProductDetailModal
  },
  data () {
    return {
      fields: {
        name: {
          label: 'Product',
          thStyle: 'width: 30%;',
          sortable: true
        },
        location: {
          label: 'Locaties',
          thStyle: 'width: 20%;',
          sortable: true
        },
        brand: {
          label: 'Merk',
          thStyle: 'width: 20%;',
          sortable: true
        },
        stock_quantity: {
          label: 'Voorraad',
          thStyle: 'width: 20%;',
          sortable: true
        }
      },
      detailModalProductId: null
    }
  },
  methods: {
    findAllProducts (params) {
      return http.get('/products-unknown', { params })
    },
    details (product) {
      this.detailModalProductId = product.id
    },
    refresh () {
      this.$refs.productsTable.refresh()
    }
  }
}
</script>



// WEBPACK FOOTER //
// UnknownProductsPage.vue?8eeb41b2